// src/lib/firestore/planPointsMapping.js

/**
 * Lookup Keys to Stripe Price IDs Mapping
 * 
 * Define friendly lookup keys that map to actual Stripe Price IDs.
 * Ensure that these lookup keys are unique and descriptive.
 */
export const priceLookup = {
    // 'test_daily': 'price_1Q1QwYLwVFtniydbkI2OlKq8',  // £1.00 Daily
    'standard_plan_three': 'price_1Q5prLLwVFtniydbWLu6ItrR', // £6.99 Monthly 
    'standard_monthly': 'price_1PiFywLwVFtniydb0Z9cjTL3', // £12.99 Monthly
    'premium_monthly': 'price_1PiFywLwVFtniydbZdeHCnsT', // £19.99 Monthly
    'gold_monthly': 'price_1PiFywLwVFtniydb0DcL7mxn', // £29.99 Monthly
    'hundy_club': 'price_1QuNLaLwVFtniydbR88sazWp', // £100 Monthly
    // Add more lookup keys and Price IDs as needed
};

export const reversePriceLookup = {
    'price_1Q1QwYLwVFtniydbkI2OlKq8': {
        cost: '£1.00 a day',
        name: "Test",
        saving: "Save 50%",
        extra: "£1 for £2 in credit",
    },
    'price_1Q5prLLwVFtniydbWLu6ItrR': {
        cost: '£6.99 a month',
        name: 'Basic',
        saving: "Save 36%",
        extra: "£6.99 for £11 in credit"
    },
    'price_1PiFywLwVFtniydb0Z9cjTL3': {
        cost: '£12.99 a month',
        name: 'Standard',
        saving: "Save 40%",
        extra: "£12.99 for £22 in credit"
    },
    'price_1PiFywLwVFtniydbZdeHCnsT': {
        cost: '£19.99 a month',
        name: 'Premium',
        saving: "Save 44%",
        extra: "£19.99 for £36 in credit"
    },
    'price_1PiFywLwVFtniydb0DcL7mxn': {
        cost: '£29.99 a month',
        name: 'Gold',
        saving: "Save 50%",
        extra: "£29.99 for £60 in points"
    },
    'price_1QuNLaLwVFtniydbR88sazWp': {
        cost: '£100 a month',
        name: 'GOAT Club',
        saving: "Save 50%",
        extra: "£100 for £200 in points"
    },
    // Add more mappings as needed
};

/**
 * Subscription Lookup Keys to Points Mapping
 * 
 * Define the number of points to add based on the subscription lookup key.
 * Ensure that the lookup keys match those defined in priceLookup.js.
 */
export const lookupPointsMapping = {
    'test_daily': 2,        // Daily Test Plan grants 2 points
    'standard_plan_three': 11,     // Basic Monthly Plan grants 50 points
    'standard_monthly': 22,
    'premium_monthly': 36,  // Premium Monthly Plan grants 100 points
    'gold_monthly': 60,     // Gold Monthly Plan grants 200 points
    'hundy_club': 200,      // GOAT Club Plan grants 500 points
    // Add more lookup keys and points as needed
};

/**
 * Retrieves the points to add based on the subscription Price ID by using lookup keys.
 * 
 * @param {string} priceId - The Stripe subscription Price ID.
 * @returns {number} - The number of points to add.
 */
export function getPointsForPrice(priceId) {
    // Find the lookup key corresponding to the provided Price ID
    const lookupKey = Object.keys(priceLookup).find(key => priceLookup[key] === priceId);
    
    if (!lookupKey) {
        console.warn(`No lookup key found for Price ID: ${priceId}.`);
        return 0;
    }

    // Retrieve the points based on the lookup key
    return lookupPointsMapping[lookupKey] || 0;
}